import { useDispatch, useSelector } from 'react-redux'
import { RootState, ToolsDispatch } from './types'

export const useToolsDispatch = () => useDispatch<ToolsDispatch>()
export const useToolsSelector = useSelector.withTypes<RootState>()
